import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {Helmet}  from 'react-helmet';
import  PageHeader          from './PageHeader';
// import { history }  from '../routers/AppRouter'
import   jwt from 'jsonwebtoken';
// import { FooterSection } from './FooterSection'; 

import   format from 'date-fns/format';
import   isEqual from 'date-fns/isEqual';
import   isEmpty  from 'lodash/isEmpty';
import   isObject  from '../utils/general';
import   PicGetRequest  from '../apis/PicGetRequest';
import   PicPutRequest  from '../apis/PicPutRequest';
import   contactExist   from '../apis/contact/contactExist';
import   participantExist from '../apis/participant/participantExist';
import   updateParticipantAttendance from '../apis/participant/updateParticipantAttendance';
import   getAttendeeStatus from '../apis/participant/getAttendeeStatus';
import   TextButtonGroup from './buttons/TextButtonGroup';
import   PicInvitationContribPanel  from './PicInvitationContribPanel';
import   PicInvitationHelpPanel  from './PicInvitationHelpPanel';
import { ErrorMessage } from './ErrorMessage';
import { SimpleButton } from './buttons/SimpleButton';
import { TextButton } from './buttons/TextButton';
import { HorizRule } from './decorators/HorizRule';
import   EmailModal        from './modals/EmailModal';
import   NameEmailModal  from './modals/NameEmailModal';
import   MessageModal  from './modals/MessageModal';
import  { CancelSubmitModal }  from './modals/CancelSubmitModal';
import  getAppConfigParm  from '../config/AppConfig';
import  Footer from "../components/common/Footer";
import  ProgressSpinner from './ProgressSpinner'
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import  LinkIcon from '@material-ui/icons/Link';
import ShareableLink from './links/ShareableLink';
import TokenizedUrl  from '../utils/TokenizedUrl';
import { prtStart, prtInput, prtMsg, prtVar, prtErr }   from  '../utils/prt';
import addNewParticipant from '../apis/participant/addNewParticipant';
import MuiToolTip from './popups/MuiToolTip';
import { displayAd } from './advertisements/helpers/displayAd';

// import { GoogleAdInit } from './advertisement/GoogleAdInit';

const FNAME = "PicInvitation";
const TRACE =  true;

// *************************************************************************************************
// Component process
// When component mounts the following occurs:
//   - componentDidMount pulls off token from url and decodes it
//   - get event id and participant id from decoded token. If user was not invited by organizer but 
//     was given a shared link to the event, then decoded token would only have the eid property set.
//   - componentDidMount fires off a chain of api calls to get eventObj, the contribution list,
//     and the helping hands list and saves info in local state
// In the render():
//   - Component renders event details with a Shareable link
//   - It also renders an RSVP prompt asking user if attending, yes or no?
//   - Provides user option to Pitch In. 
//   - If user was in the invitee list, when they click the 'Count Me in' button, their name would appear.
//   - If user was NOT on the invitee list and was provided a shareable link instead, 
//     then they will be prompted to enter their name and email when they click either yes on the
//     RSVP text button or the 'Count Me in' button.
// *************************************************************************************************
// To Test this page in Dev Environment, you can do it one of 2 ways: 
// 1)change the route from a public route to a private route, then copy and 
//   paste the "view inviation url", sent in the email, to the browser. 
// 2)Log off the application in Dev then click invitation
//   button on the invitation email.
// *************************************************************************************************
// FUTURE STATE: whenever you need to render a page both for internal user and external user, be 
//  sure to adhere to following guidelines:
//  - Ensure page has only presentation logic
//  - You typically will not set up a redux store for a single page (especially if used as exteral page
//    addition to internal page). Therefore, use real-time api calls instead of redux store. Store 
//    data locally in the class/Component. This will avoid any logic needed to determine if you are
//    getting data from redux store, geting it directly from the api, or local variables.
//  - Separate out API call(s) to external file (eg. api/fetchEventInfo())
//  - If API requires promise chaining, return one data object with the various results as properties.
//  - If you want to be able to use the API for both external and internal page, provide an 
//    option, parm, or setting to either call API's public route or private route. This keeps this 
//    logic outside the presentation logic.
//  - Routes should be preconfigured. Any parms needed to complete the url string, for example the
//    event id  (eg. /event/:id), should passed as a paramter to api.
// ***************************************************************************


const TopBorder = () => (
    <div className="pic-event-tb"/> 
);

/* This is presentation function called by the eventDetailSection */
const renderDateAndTime = (startDate, startTime, endDate, endTime) => { 

    /* set flag as to whether startdate and enddate are the same */
    let isStartAndEndDateEqual = isEqual(startDate, endDate);

    /* construct Jsx for when start and end dates are same */
    let sameDayJsx = (
        <div>
            <span>Date/Time:&nbsp;</span> <span className="invites-event-field">{`${format(startDate, 'MMMM dd, YYYY')} -  `}</span>
            &nbsp;&nbsp;&nbsp;
            <span className="invites-event-date">{`${format(startTime, 'hh:mm a')} - ${format(endTime,'hh:mm a')}`}</span>
        </div>
    )

    /* construct Jsx for when start and end dates are different */
    let differentDaysJsx = (
        <div className="pic-event-detail-sectionx" style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div  className="pic-event-label">Date/Time:</div> 
                <div className="invites-event-field">{`${format(startDate, 'MMM dd, YYYY')}  -  ${format(startTime,'hh:mm a')}`}</div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div className="pic-event-label">To :&nbsp;</div> 
                <div className="invites-event-field">{`${format(endDate, 'MMM dd, YYYY')} - ${format(endTime, 'hh:mm a')}`}</div>
            </div>
        </div>
    )

    /* render jsx based on condition */
    if (isStartAndEndDateEqual) {
        return sameDayJsx;
    } else {
        return differentDaysJsx;
    }
}

/* Presentation function used to render event detail section  */
const eventDetailSection = (_id, title, location, startDate, startTime, endDate, endTime,  organizer, message, clearPage) =>  {
    // let errormsg = this.state.formError || '';
    TRACE && prtStart(FNAME, 'eventDetailSection');
    //TRACE && prtInput('_id', _id);
    //TRACE && prtInput('title', title);
    //TRACE && prtInput('location', location);
    //TRACE && prtInput('message', message);
    //TRACE && prtInput('clearPage', clearPage);

    // Set user id to "none" and entity id to event id on the payload used to construct tokenized url. This tokenized url 
    // can be used by user who received invitation to share the link with others.
    _id = _id ? _id : "none";              /* this will prevent id being null on initial render,until data is avaliable */
    let payLoad = { uid: "none", eid: _id };  
    let inviteUrl = getAppConfigParm("inviteUrl");

    TRACE && prtVar("inviteUrl", inviteUrl);
    /** Note that the {token} string is a part of the url pattern passed into TokenizedUrl and not a template variable */
    let tokenizedUrl = new TokenizedUrl(`${inviteUrl}/{token}`, payLoad );
    let shareableLink = tokenizedUrl.get();
    TRACE && prtVar("shareableLink", shareableLink);
    if (!shareableLink) { prtErr("Problem constructing tokenizedUrl. Check error log") } ;

    return (
        <div>
            <div className="pic-event-detail-section">
                <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb=".5rem" />
                <div className="pic-event-title">{title}</div> 
                <div style={{display: 'flex', justifyContent: 'center', marginTop: '-.5rem'}}>
                    <ShareableLink urlString={tokenizedUrl.get()} linkName={title} />   
                </div> 
                <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb=".5rem" />
                <div style={{display: 'flex'}}>
                    <div className="pic-event-label">Organizer:</div>
                    <div className="invites-event-field">{organizer} </div>
                </div>

                <div>{renderDateAndTime(startDate, startTime, endDate, endTime)}</div>

                <div className="rc-flex-container-r2c">
                    <div className="pic-event-label">Location:&nbsp;</div>
                    <div className="invites-event-field">{location}</div>
                </div>                
            </div>
            {!clearPage && 
                <div className="pic-event-detail-section">
                    <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb=".50rem" />
                    <div className="pic-event-label">Message:&nbsp;</div>
                    <div className="pic-event-message">{message}</div>
                </div>
            }
        </div>
    )
}

// This page uses the PicEventsTable component. This a flex table component that 
// takes as props an array of rows (each row has array of column/cells) that allows for a 
// fixed number of columns (eg 3 or 4). Note that the contents of each cell or column
// in the flex table can be text or jsx. The mapping of the data to the JSX structures
// is done in the componentDidMount lifecycle method.
export class PicInvitation extends React.Component { 

    constructor(props) {
        // TRACE &&prtStart(compName, 'constructor');
        super(props);

        this.state = {
            eventObj: { eventTitle: 'Fetching Event Information....'},  /* Initialize eventTitle with msg, otherwise it shows undefined  */
            contributions: [],
            helpingHandsList: [],
            participantEmail: '',
            participantName:  '',
            inviteSentBy:   'organizer',             /* indicates who sent invite; the organizer or an invited user via shareable link */
            showCancelSubmitModal: false,
            showEmailModal: false,                  /* This modal is only used when use wants to Retrieve previously submitted response */
            emailModalTitle: "Provide email to retrieve your previous response",
            showNameEmailModal: false,
            nameEmailModalTitle: "Please provide Name and Email",
            showMessageModal: false,
            clearNameEmailModalCheckMarks: false,      /* used may NameEmailModal to checkMarks when user cancels modal w/out submitting */
            userMadeContribution: false,   /* pops up modal if user submits response without contribution */
            // headerLabels: ["Item Description", "Qty Needed", "Contribution", ""],
            panel1IconOpen:    false,   /* false means icon close position, true is open position*/
            panel2IconOpen:    false,   /* false means icon close position, true is open position*/
            displayLists:  false,
            rsvpFlag:      "",   /* used to know when to put check mark next to text button */
            clearPage:     false,   /* set to true when user clicks pitch in button. Clears screen to show lists */
            attend:  "n",         /* participant attendance is set to No as default */
            responseSubmitted: false,  /* When this is true Submit response button is hidden and message is displayed */
            externalToken: '',       /* token from external user */
            buttonClickedValue: 0,   /* used by TextButtonGroup to indicate which text button was clicked */
            textButtonCheckMarks: {checkMark1: false,  checkMark2: false},  /* manage checkMark toggle on TextButtonGroup */ 
            dataLoaded:  false,
            formError: ''
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    // ComponentDidMount does the following:
    // (1) pulls the token from the url, decodes payload and pulls off the event id and participant email.
    // (2) It then constructs the url requests to the public routes. 
    // (3) It makes a chain of api calls to get the event info, contribution list, and help-hands list.
    componentDidMount = () => {
        //TRACE && prtStart(FNAME, "componentDidMount");

        let self = this;

        // Set up working variables needed for processing token payload and all API calls
        let eventObj = {};
        let event_id = '';
        let contributions = [];
        let token = '';
        let participantEmail = '';
        let contrib_uri = '';
        let decodedToken = '';
        let get_event_uri = '';
        let get_helplist_uri = '';
        let get_participant_uri = '';
        
        /* Set up appropriate routes and token based on whether user is external or is logged in and authenticated*/
        //TRACE && prtMsg("Inside the EXTERNAL REQUEST block")

        /* (0) When component is mounted, reset dataLoaded to false */
        this.setState({dataLoaded: false})

        /* (1) get token */
        token = this.props.match.params.token;
        //TRACE && prtVar("token", token)
        this.setState({externalToken: token});  /* save external token so it may be used by other api calls outside componentDidMount */

        /* verify token is valid; Note: tokenizedUrl class has knowledge of key needed to decode token  */
        let tokenizedUrl = new TokenizedUrl();
        if (tokenizedUrl.isValidToken(token)) {
            decodedToken = tokenizedUrl.getPayload();
        } else {
            this.setState({formError: "InvalidUrl: string may have been corrupted. Try clicking on invitation email again"});
        }

        /* Check which payload was sent via jwt token. If payload object has an event_id and email property, then link was sent by organizer.
            If payload object has an eid property instead, the link was sent anonymously to another person via the shareable link.  */
        if (decodedToken.email && decodedToken.event_id) {
            /* get participantEmail and event id  from decoded token */
            participantEmail = decodedToken.email;
            event_id  = decodedToken.event_id;     
            //TRACE && prtVar(`decodedToken: ${JSON.stringify(decodedToken)}`)
        } else {
            participantEmail = decodedToken.uid;  /* uid value should be "none" */
            event_id  = decodedToken.eid;  
            this.setState({inviteSentBy: "anonymous"});
            //TRACE && prtVar(`decodedToken: ${JSON.stringify(decodedToken)}`)
        }

        /* (2) define public uris for the api calls*/
        contrib_uri   = `/invitation/event/${event_id}/contributions/${participantEmail}`; /* public route */
        get_event_uri = `/event/${event_id}/participant/${participantEmail}/name`; /* this one reads participants collection to get name */
        get_helplist_uri = `/invitation/event/${event_id}/todos/${participantEmail}`;
        get_participant_uri = `/event/${event_id}/participant/${participantEmail}`;  /* This same uri as the internal request */

        //TRACE && prtVar("this.state.formError", `'${this.state.formError}'`)
        if (this.state.formError) return;        /* get out here if error encountered */
       
        //TRACE && prtMsg("Starting API call chain");
        /* (3) Fire API Request to get Event info along with participant name; Note this public route is used for both internal and external requests  
           For external requests, the token is not set */
        let step = "notStarted";
        let getRequest = new PicGetRequest("GetEventById")
            .setUserId(participantEmail)
            .setUri(get_event_uri)
            .setLogTrace(false);
            // if (!isExternalRequest) { getRequest.setAuthToken(token); } /* set token for internal request */   // OLD CODE
            step = "getEvent";    /* This step gets event info along with participant name from  participants collection */         
            getRequest.exec().then((response) => {
                eventObj = response.data || {};
                //TRACE && prtVar("eventObj: ", JSON.stringify(eventObj,null,2));
                eventObj.participantEmail = participantEmail;  /* add participantEmail property to object */
                eventObj._id = event_id;
                self.setState({eventObj, participantEmail, participantName: eventObj.participantName});     // NEW CODE
                /* set up request to get contributions */
                step = "getContributions";
                let getContributionsRequest = new PicGetRequest("GetContributions")
                .setUserId(participantEmail)
                .setUri(`${contrib_uri}`)
                .setLogTrace(false);
                //  if (!isExternalRequest) { getContributionsRequest.setAuthToken(token); } /* set token for internal request */ // OLD CODE
                return getContributionsRequest.exec()
        }).then ((response) => {
                let contribList = response.data.items || [] ;
                contributions = this.mapContribDataToFlexTable(contribList);
                this.setState({contributions, panel1IconOpen: false});
                /* set up request to get contributions */
                step = "getHelpingHandsList";
                let getHelpListRequest = new PicGetRequest("GetHelpingHandsList")
                .setUserId(participantEmail)
                .setUri(`${get_helplist_uri}`)
                .setLogTrace(false);
                // if (!isExternalRequest) { getHelpListRequest.setAuthToken(token); } /* set token for internal request */ // OLD CODE
                return getHelpListRequest.exec()
        }).then ((response) => {
            let hhList = response.data.todos || [] ;
            let helpingHandsList = this.mapHelpDataToFlexTable(hhList);
            // helpingHandsList = this.mapHelpDataToFlexTable(hhList);   // <<< ============== NEXT
            this.setState({helpingHandsList, panel2IconOpen: false});
            step = "getAttendeeStatus";
            let getAttendeeStatus = new PicGetRequest("getAttendeeStatus")
            .setUserId(participantEmail)
            .setUri(`${get_participant_uri}`)  /* The participant object returned contains attendee status */
            .setLogTrace(false)
            .setAuthToken(token);
            // if (!isExternalRequest) { getAttendeeStatus.setAuthToken(token); } /* set token for internal request */    // OLD CODE
            return getAttendeeStatus.exec()    
        }).then ((response) => { 
            let participantInfo = response.data.participant;  /* get participant info from response object*/
            let rsvpFlag = '';     /* initialize local rsvpFlag */ 
            let checkMark1= false;
            let checkMark2= false;
            let buttonClickedValue = 0;
            let attendStatus = participantInfo ? participantInfo.attend : "";  /* get the participant attend status from database*/
            if (attendStatus === 'y' ) {   /* set the rsvpFlag and buttonClickedValue based on database attendStatus value */
                rsvpFlag = "yes";
                buttonClickedValue = 1;
                checkMark1 = true;
            } else  if (attendStatus === 'n') {
                rsvpFlag = "no"
                buttonClickedValue = 2;
                checkMark2   = true;
            } else {
                rsvpFlag = attendStatus
                buttonClickedValue = 0;
            }
            this.setState({ rsvpFlag, buttonClickedValue, textButtonCheckMarks: {checkMark1:checkMark1, checkMark2:checkMark2}, dataLoaded: true});
        }).catch((error) => {
            prtErr(error);
            let errmsg = '';
            switch (step) {
                case "getEvent":
                    if (error.status === 404) {
                        errmsg = `NotFound: did not find participant email '${participantEmail}' for given event`
                    }
                    break;
                case "getHelpingHandsList":
                        errmsg = `Error: found in ${step} for user '${participantEmail}' for event '${event_id}'`
                    break;
                default: 
                    errmsg = `Encountered error ${error} in ${step} request`;
            }
            self.setState({formError: errmsg, dataLoaded: true})
        });
    } /* end of component did mount */

    //*************************************************************************
    // Event Handlers
    //*************************************************************************

    /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
    clearErrorMessage = () => {
        this.setState({formError: ''})
    }

    /* This is fired when user clicks caret icon on the expansion panel1 */
    handleOnClickForPanel1 = () => {
        let yes  = true;
        let no  = false;

        /* user clicked icon, therefore flip state */
        let panel1IconOpen = !this.state.panel1IconOpen

        /* makes sure both tables are not expanded at the same time. If panel2 is open when panel1 icon clicked,
           then close it  */
        if (panel1IconOpen === true)  {  
            this.setState({panel1IconOpen: true, panel2IconOpen: false })   
        } else if (panel1IconOpen === false) {
            this.setState({panel1IconOpen: false})    
        }
    } 

    /* This is fired when user clicks caret icon on the expansion panel2 bar */
    handleOnClickForPanel2 = () => {
        let yes  = true;
        let no  = false;

        /* user clicked icon, therefore flip state */
        let panel2IconOpen = !this.state.panel2IconOpen

        /* makes sure both tables are not expanded at the same time. If panel1 is open when panel2 icon clicked,
           then close it  */
        if (panel2IconOpen === true)  {  /* reset flag to hide message */
            this.setState({ panel2IconOpen: true, panel1IconOpen: false})   
        } else if (panel2IconOpen === false) {
            this.setState({ panel2IconOpen: false})    
        }
    } 

    /* This is fired when user clicks on one of the buttons in the TextButtonGroup  */
    /* Note, if user made 1 contribution without rsvp'ing and clicked submit, they 
       would see error message. Once they rsvp, the submit button immedialy goes away.
       You don't want that. It's preferable to keep submit button there in event they
       want to make another contribution or change contribution after they rsvp. This
       is why you will see submit response flag reset below everytime a text button is clicked.
       This will maintain submit button there until user explicitly clicks on it.

       Note, reset value is passed by child component via callback. If user clicks on textbutton
       2 x's it puts check on text button clicked the first time , and takes it off the second time.
       This resetValue lets us (the parent know) that child component button 1 was clicked and as a
       result, its check mark was removed , or reset. resetValue in this case would be 0;
       */
    
    handleTextButtonGroup = (buttonClickedValue) => {
        //TRACE && && prtStart(FNAME, "handleTextButtonGroup");
        //TRACE && && prtVar(buttonClickedValue, "buttonClickedValue");

        let { textButtonCheckMarks } = this.state;

        /* If user cancels the modal, the text button checkmarks are cleared off the TextButtonGroup . 
           Next time a user clicks a text button, lets turn off the clearCheckMarks flag.  */
        this.setState({clearNameEmailModalCheckMarks: false});

        /* Since user just clicked a text button, lets toggle the checkMark for the button clicked so code below can work with the new state */
        let checkMark1 = buttonClickedValue === 1 ?   !textButtonCheckMarks.checkMark1 : textButtonCheckMarks.checkMark1 ;
        let checkMark2 = buttonClickedValue === 2 ?   !textButtonCheckMarks.checkMark2 : textButtonCheckMarks.checkMark2 ;

        /* check if this is anonymous invitee. If so, show modal to get their name and email first , then proceed w/ button selection */
        if (this.state.participantEmail === "none" || this.state.participantEmail === "" ) {
            //TRACE && prtMsg("This is an anonymous invitee.")
            this.setState({showNameEmailModal: true, nameEmailModalTitle: "Please provide Name and Email"});
        }

        if (buttonClickedValue === 1 && checkMark1) {
            this.setState((state) => {
                return {
                    rsvpFlag: "yes", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: checkMark1,  checkMark2: false }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } else 
        if (buttonClickedValue === 1 && !checkMark1) {
            this.setState((state) => {
                return {
                    rsvpFlag: "", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: checkMark1,  checkMark2: false }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } else 
        if (buttonClickedValue === 2 &&  checkMark2) {
            this.setState((state) => {
                return {
                    rsvpFlag: "no", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: false,  checkMark2: checkMark2 }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } else
        if (buttonClickedValue === 2 && !checkMark2) {
            this.setState((state) => {
                return {
                    rsvpFlag: "", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: false,  checkMark2: checkMark2 }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } 

        /* clear form error if one exist */
        if (this.state.formError) { 
            this.clearErrorMessage();
        }
    }
    
    /* Called by child component to raise error */
    handleRaiseError = (text) => {
        this.setState({formError: text});
    }

    handleOnClickBackButton = () => {
        /* Go back by dynamically rendering first page where we do not clearPage or display lists */
        this.setState({ clearPage: false, displayLists: false });
    }

    handleSubmitResponse = (e, userMadeContribution_override) => {
        // TRACE && prtStart(FNAME, "handleSubmitResponse");

        // TRACE && prtInput("e", e)
        // TRACE && prtInput("userMadeContribution_override", userMadeContribution_override);

        /* Set up state variables */
        let { eventObj, participantEmail, participantName, rsvpFlag, inviteSentBy, externalToken, userMadeContribution } 
            = this.state;

        /* Validation step: check that user answerered question, Are you Attending?*/
        if (this.state.rsvpFlag === "") {
            this.handleRaiseError("RSVP Missing: Please let us know if you will be attending");
            return;
        } 

        /* Set up state decision variables */

        /* This variable normally comes from the state, except when user hits submit from modal asking if user wants to pitch in */
        /* In that case, the user does not want to pitch in so the value in userMadeContribution is overriden and set to true, so we submit response. */
        // userMadeContribution = userMadeContribution_override || userMadeContribution;

        // TRACE && prtMsg(userMadeContribution ? "User made contribution" : "User did not make contriubtion");

        /* The userMadeContribution variable normally comes from the state, except when user hits submit from modal asking if user wants to pitch in. */
        /* In that case, the user does not want to pitch in, so the value in userMadeContribution is overriden and set to true so we can submit the response. */
        /* Otherwise, we're going to check if user is in one of the lists by using the 'isInOneOfTheParticipantLists()' function. Note this is the only
           place I use this function. Everywhere else I rely on the state variable "this.state.userMadeContribution".  The function was introduced 
           specifically to handle scenario where anonymouse user already pitched in but came back to view invite and clicks submit again.  If they
           came back and had already participated, there is no need to ask user to pitch in again */  
        userMadeContribution = userMadeContribution_override || 
                               this.isInOneOfTheParticipantLists(participantEmail, this.state.contributions, this.state.helpingHandsList);  
                            //    userMadeContribution;
        // TRACE && prtVar("userMadeContribution",userMadeContribution)
        // TRACE && prtVar("rsvpFlag", rsvpFlag);

        /* If there is no contribution or helpinghands list, there is no reason to show modal to remind user to pitch in  */
        if (this.isNoLists()) {
            // TRACE && prtMsg("Both contributions and helpings hands are empty")
            this.setState({showCancelSubmitModal: false});
        } else if (rsvpFlag !== ""  && !userMadeContribution) {  /* we do have lists and user rsvp'd and made contribution; then show modal */
            // TRACE && prtMsg("One or both lists have entries but user has not contributed; show modal to contribute")
            this.setState({showCancelSubmitModal: true});
            return;
        } else {                                                /* reset to false as default behavior if prior conditions were not met */
            // TRACE  && prtMsg("User RSVP'd and made contributions; set show modal to contribute to false")
            if (this.state.showCancelSubmitModal) {this.setState({showCancelSubmitModal: false})}
        }

        /* If invite was sent by organizer, then update rsvpFlag and attendance in database, then close panels*/
        if (inviteSentBy === "organizer") {

            //TRACE  && prtMsg("Invite was sent by organizer")
            updateParticipantAttendance(eventObj._id, participantEmail, rsvpFlag, externalToken).then((response) => {
                this.setState({responseSubmitted: true, panel1IconOpen: false, panel2IconOpen: false})
            }).catch((error) => {
                prtErr(`This is error from update participant attendance: ${JSON.stringify(error,null,2)}`)
                errmsg = `SomethingWrong: could not process your response ${participantEmail}. May want to refresh page or try again later`
                this.setState({formError: errmsg})
            })

        } else {  /* Invite sent by anonymous.If name was not updated show modal to enter name and email. */
   
            /* before updating database, make sure user clicked on modal to enter their name first, otherwise set form error and return  */
            //TRACE  && prtMsg("Invite was sent by anonymous")
            if (participantEmail === "none") {
                this.setState({formError: "RSVP Missing:Please RSVP Yes or No"});
                return;
            }

            /* If we are here anonymous user entered name and email address */
            let participantAlreadyAdded = false;
            let addToContacts = "no";
            let foundParticipant = {};
            
            /* Check if user is already a participant and if they are in the contacts list. If they in contact list we don't want to add
               duplicates to contact so we set the addToContacts flag to true when calling the addNewParticipant API */
            participantExist(eventObj._id, participantEmail).then((data) => {
                if (data.participant) { 
                    participantAlreadyAdded = true; 
                    foundParticipant = data.participant;
                }
                return contactExist({uid: eventObj.email, eid: participantEmail}) 
            }).then((data)=> {
                if (!data.contact) {addToContacts = "yes"};
                /* do not add participant if already exist; If already exist, contact should also have been created  */
                if (!participantAlreadyAdded) {
                    return addNewParticipant(eventObj._id, eventObj.email, participantEmail, participantName, addToContacts);
                } else {
                    return Promise.resolve({participant: foundParticipant})
                }
            }).then((newParticipant) => {
                return updateParticipantAttendance(eventObj._id, participantEmail, rsvpFlag, externalToken)
            }).then((response) => {
                this.setState({responseSubmitted: true, panel1IconOpen: false, panel2IconOpen: false})
            }).catch((error) => {
                prtErr(`Issue when try to add anonymous user: ${JSON.stringify(error,null,2)}`)
                let errmsg = `SomethingWrong: could not process response for ${participantEmail}. May want to refresh page or try again later`
                this.setState({formError: errmsg});
            })
        }
    }

    /* This is fired when changing contribution value. Cange is reflected in the contribution list in parent*/ 
    handleChangeQuantity = (contributions) => {
        this.setState({contributions});
    }

      

    // =============================  Handlers for  SimpleModal ==========================================

    handleCloseModal = () => {
       /* This is called when user clicks on modal Submit text button that asks user if they want to Pitch In . 
          Note, although user did chose not to contribute, we set the userMadeContribution_override to true and the state variable to true
          so handle submit process can proceed */
       this.setState({showCancelSubmitModal: false, userMadeContribution: true});
       let userMadeContribution_override = true;
       this.handleSubmitResponse({}, userMadeContribution_override);
    //    this.setState( () => {
    //         this.handleSubmitResponse();
    //         return {showCancelSubmitModal: false}
    //    })
    }

    handleCancelModal = () => {
        this.setState({showCancelSubmitModal: false});
    }

    // ============================== Handlers for NameEmailModal ========================================

    handleCancelNameEmailModal = () => {
        this.setState({showNameEmailModal: false, rsvpFlag: "", buttonClickedValue: 0, clearNameEmailModalCheckMarks: true })
    }

    handleCloseNameEmailModal = () => {
        this.setState({showNameEmailModal: false})
    }

    /* This form is used for invites that were forwarded using ShareableLink. The user will not be known
       hence modal is presented either when they RSVP or click Count Me in button to get users name and email */
    handleSubmitNameEmailModalForm = (formData) => {
        let TRACE = false;
        TRACE  && prtStart(FNAME, "handleSubmitNameEmailModalForm")
        //TRACE  && prtInput("formData", JSON.stringify(formData,null,2));

        /* If there was a formError, like "Did not RSVP", right modal was triggered,  clear the error on submit */
        if (this.state.formError) {this.setState({formError: ""})}

        let event_id = this.state.eventObj._id;
        let participantEmail = formData.email; 
        
        //TRACE  && prtInput("event_id", event_id);

        /* Check if anonymous user is in one of the participant lists already. If so, get their attendee status to reflect in the UI. 
           otherwise */
        // this.updateRvspFlagforCurrentParticipant(event_id, participantEmail);
        if (this.isInOneOfTheParticipantLists(formData.email, this.state.contributions, this.state.helpingHandsList)) {
            TRACE && prtMsg(`${formData.email} is in one of the pitch in lists`)
            this.updateRvspFlagforCurrentParticipant(event_id, participantEmail);
            // getAttendeeStatus(event_id, participantEmail).then((data) => {
            //     let { attend } = data.participant;
            //     if (attend === "y") {
            //         this.setState({participantName: formData.name, participantEmail, rsvpFlag: "yes",
            //             textButtonCheckMarks: {checkMark1: true,  checkMark2: false},
            //             buttonClickedValue: 1, panel1IconOpen: false, panel2IconOpen: false

            //         })
            //     } else if (attend === "n") {
            //         this.setState({participantName: formData.name, participantEmail, rsvpFlag: "no",
            //             textButtonCheckMarks: {checkMark1: false,  checkMark2: true},
            //             buttonClickedValue: 2, panel1IconOpen: false, panel2IconOpen: false
            //         })
            //     }
            //     TRACE && prtMsg(`Below is attendee status for ${participantEmail}`);
            //     TRACE && prtVar("attend", attend);
            // })
        } else {
            TRACE && prtMsg(`${formData.email} is NOT in one of the pitch in lists`)
            /* If anonymous user is not in one of the participant lists, set participantName, participantEmail and
               other state variables to default attend status to "Yes" */
            this.setState({participantName: formData.name, participantEmail 
                    // rsvpFlag: "yes",
                    // textButtonCheckMarks: {checkMark1: true,  checkMark2: false},
                    // buttonClickedValue: 1
            });
        }
        // console.log(`This is contributions ${this.state.contributions}`)
        // this.setState({participantName: formData.name, participantEmail, rsvpFlag: "yes"});
    }

    /* This form is used for invites that were forwarded using ShareableLink. The user will not be known
       hence modal is presented either when they RSVP or click Count Me in button to get users name and email */
    // handleSubmitEmailModalForm = (formData) => {
    //     TRACE && prtStart(FNAME,"handleSubmitEmailModalForm");
    //     TRACE && prtInput("formData", formData);
    //     this.setState({participantEmail: formData.email});
    // }


    // ============================== Handlers for MessageModal ========================================

    handleCancelMessageModal = () => {
        // TRACE && prtStart(FNAME, "handleCancelMessageModal");
        // TRACE && prtMsg("Changing state for showMessageModal to false");
        this.setState({showMessageModal: false})
    }

    // ============================== Handler called by child component ================================

    /* this handler is used by child component to set some state values on parent (this component).
       In this case it is being used to tell parent that an anonymous user tried to delete themselves from list
       in a child component, but we don't know who it is. We need to prompt for their name and email address 
       using NameEmail modal */
    handleSetParentStateValues = (parentValues) => {
        this.setState(parentValues)
    }

    // ============================== Handle Count me in button for Contributions ================================

    handleContribCountMeInButton = (indexValue) => {
        //TRACE &&prtStart(FNAME, "handleOnClickContribution")

        /* save last index value so that modal can resume processing */
        this.lastContribIndexValue = indexValue;
        
        /* First and foremost get username and  user-email to be able to track who is participating */
        /* If user is logged in, use the name of the authorized user */
        let contributions = this.state.contributions;

        let participantName  = this.state.participantName;
        let participantEmail = this.state.participantEmail;

        if (participantEmail === "none") {
            //TRACE &&prtVar("participantEmail", participantEmail); 
            // this.setState({showMessageModal: true})
            this.setState({showNameEmailModal: true, nameEmailModalTitle: "First provide name and email, then click Count Me In"})
            return;
        }

        //TRACE &&prtMsg("This partcipant name and email ")
        //TRACE &&prtVar("participantName", participantName);
        //TRACE &&prtVar("participantEmail", participantEmail);
        //TRACE &&prtVar("Parent participantEmail", this.props.getParentStateValue("participantEmail"));
        //TRACE &&prtVar("Parent participantName", this.props.getParentStateValue("participantName"));

        /* Set quantity needed and set contribution */
        let quantityNeeded = contributions[indexValue][1];
        let contribution =  contributions[indexValue][2]
        
        /* Check input. If valid, add user to list */
        if (contribution > quantityNeeded) {
            this.handleRaiseError("Note: Quantity exceeded quantity needed. Lower contribution.");
        } else 
        if (contribution < 1 && contribution > -1) {
            this.handleRaiseError("Note: Contribution cannot be 0.");
        } else 
        if (contribution < 0) {
            this.handleRaiseError("Note: Contribution cannot be negative value." );
        } else {
            // console.log(`User ${participantName} with email ${participantEmail} is contributing ${contribution}  item`)
            let contributionsCopy = [...contributions];
            
            /* update contributions list with new Quantity based on contribution amount  */
            let newQuantityNeeded = quantityNeeded - contribution;
            contributionsCopy[indexValue][1]  = newQuantityNeeded;

            /* mark item as updated */
            contributionsCopy[indexValue][5]  = "updated";

            /* construct contributor object */     
            let contributor = {
                email: participantEmail,
                name:  participantName,
                amount: contribution
            }
            /* Get participants index value in contributor list for the updateContributorList function */
            let contributorIndexValue = this.getContributorIndexValue(contributionsCopy, contributor, indexValue);

            /* Update the contributor list with the contribution amount. Index value is effectively the table row number */
            this.updateContributorsList(contributionsCopy, contributor, indexValue, contributorIndexValue);

            // console.log("INDEX VALUE AT HANDLE ON CLICK CONTRIBUTION END ", indexValue);

            //TRACE &&prtMsg("Call handleChangeDataSet2 function on PicInvitation to update contrib list on database")
            /* update list on database */            
            this.handleUpdateContributionList(contributionsCopy, indexValue, newQuantityNeeded);
        }
    }

    getContributorIndexValue = (contributionList, contributor, indexValue) => {
        let participantEmail = contributor.email;
        let contributorList  = this.getContributorList(contributionList, indexValue);
        return contributorList.findIndex(contributor => contributor.email === participantEmail);
    }
    updateContributorsList = (contributionList, contributor, indexValue, contributorIndexValue) => {
        /* In contributorIndexValue is -1 then participant is not in contribution list. Add contributor 
           to front of the list. If contributorIndexValue > -1, update in place */
        let contributorList  = this.getContributorList(contributionList, indexValue);
        if (contributorIndexValue === -1) {
            contributorList.unshift(contributor);
        } else 
        if (contributorIndexValue > -1) {
            contributorList[contributorIndexValue] = contributor;
        }
    }

    /* Fired after Count me in button handler to update database (Count Me In Button)*/
    handleUpdateContributionList = (contributions, indexValue, newQuantityNeeded) => {
        //TRACE  && prtStart(FNAME, "handleUpdateContributionList");
        //TRACE  && prtInput("contributions", JSON.stringify(contributions,null,2));
        //TRACE  && prtInput("indexValue", JSON.stringify(indexValue,null,2));
        //TRACE  && prtInput("newQuantityNeeded", JSON.stringify(newQuantityNeeded,null,2));
        
        let { eventObj, participantEmail, responseSubmitted } = this.state
        
        //TRACE && prtVar("participantEmail", participantEmail) 

        /* If user clicked Count Me In button, and responseSubmitted is true, then reset it to false in order to clear out 
        the ThankyouMessage and show submit button again */
        if (responseSubmitted) {
            this.setState({responseSubmitted: false})
        }

        /* Whether its an known or anonymous user, don't let them contribute before RSVP'ing */
        if (this.state.rsvpFlag === "") {this.setState({formError:"RSVP Missing:Please RSVP Yes or No"})}

        /* It there was a previous error that was not cleared by user, clear it before moving forward */
        if (this.state.formError) this.clearErrorMessage();

        /* get token from local state  */
        let token = this.state.externalToken;

        /* get item */
        let item = contributions[indexValue][0];

        /* get contributor list */
        let contributorList = this.getContributorList(contributions, indexValue);
        
        //TRACE && prtMsg("This is the contributor list for the indexed value")
        //TRACE && console.log(JSON.stringify(contributorList,null,2))

        /* construct request object */
        let updateContributorsReqObj = {
            event_id: eventObj._id,
            item,
            contributorList,
            quantity: newQuantityNeeded
        }

        //TRACE && prtMsg("This is request object being passed to API to update contributors")
        //TRACE && console.log(JSON.stringify(updateContributorsReqObj,null,2))

        /* set uri based on whether this is external user or application user */
        let uri = this.props.auth.isAuthenticated ? '/event/participant/contributors' : '/event/invite/participant/contributors';

        /* Update database with the updated ContributorList  */
        let updateItemContributors = new PicPutRequest("updateItemContributors")
            .setUserId(participantEmail)
            .setUri(uri)
            .setRequestBody(updateContributorsReqObj)
            .setAuthToken(token)                       
            .setLogTrace(false);     
        updateItemContributors.exec().then((response) => {
            this.setState({contributions, userMadeContribution: true })
        }).catch((error) => {
            let errorResponse = updateItemContributors.getError();
            let errmsg = '';
            errmsg = `SomethingWrong: unable to update attendance for participant ${participantEmail}. May want to refresh page or try again later`
            this.setState({formError: errmsg})
        });
    }


    // ============================== Handle Count me in button for Helping Hands List ================================

    /* This is fired when user clicks the "Count Me In" button. After validating input, this
       handler will update the contributors list with the participants contribution. Note that 
       the participant is referred to as the contributor in this handler. Also note that the 
       item is marked as updated. This is for purposes of only sending updated items 
       to the API, as opposed to sending entire list   */
    handleHelpingHandsCountMeInButton = (indexValue) => {
        //TRACE  && prtStart(FNAME, "handleHelpingHandsCountMeInButton");
        //TRACE  && prtInput("indexValue", indexValue);

        if (this.props.mockMode) {return;}

        /* First and foremost get username and  user-email to be able to track who is participating */
        /* If user is logged in, use the name of the authorized user */
        let helpingHandsList = this.state.helpingHandsList;

        //TRACE && prtMsg("Following input comes from 'this.props.dataset2'")
        //TRACE && prtInput("helpingHandsList ", helpingHandsList)

        // let participantName  = this.getParticipantName();
        // let participantEmail = this.getParticipantEmail();

        let participantName  = this.state.participantName;
        let participantEmail = this.state.participantEmail;

        if (participantEmail === "none") {
            //TRACE && prtVar("participantEmail", participantEmail); 
            // nameEmailModalTitle: "Please provide name and email first",
            this.setState({showNameEmailModal: true, nameEmailModalTitle: "First provide name and email, then click Count Me In"})
            return;
        }

        /* Set quantity needed and set contribution */
        let peopleNeeded = helpingHandsList[indexValue][1];
        
        let helpingHandsListCopy = [...helpingHandsList];
        
        /* decrement number of people need by 1. If 0 , do nothing  */
        peopleNeeded = peopleNeeded === 0 ? 0 : peopleNeeded - 1;
        helpingHandsListCopy[indexValue][1]  = peopleNeeded;


        /* mark item as updated */
        helpingHandsListCopy[indexValue][4]  = "updated";

        /* construct help participant object */     
        let participant = {
            email: participantEmail,
            name:  participantName
        }

        /* if participant not on list, add in front the participants array */
        if (!this.isParticipantOnList(indexValue)) {
            let participantList  = this.getParticipantList(helpingHandsListCopy, indexValue);
            participantList.unshift(participant);
            helpingHandsListCopy[indexValue][3] = participantList;  /* 3 is column for array */
        }

        /* update list on database */            
        this.handleUpdateHelpingHandsList(helpingHandsListCopy);
    }

    /* helper function used by handleHelpingHandsCountMeInButton */
    isParticipantOnList = (rowIndex) => {
        let helpingHandsList = this.state.helpingHandsList;
        let participantEmail = this.state.participantEmail;
     
        let contributorsList = helpingHandsList[rowIndex][3];  /* column 3 has the contributors list */
        let indexFound = contributorsList.findIndex(contributor => contributor.email === participantEmail);
        return indexFound === -1 ? false : true;
    }

    /* Helper function used by handleHelpingHandsCountMeInButton. Contributor list is found as 4th item in table row . 
       Created this help function so that in event it moves, I only need to change it one place */
    getParticipantList = (helpingHandsList, rowIndex) => {
        return helpingHandsList[rowIndex][3];
    }

     

    mapHelpingHandsListToDocument= (helpingHandsList) => {
        let todos =  helpingHandsList.map((item) => {
            return {
                todo: item[0],
                peopleNeeded: item[1],
                participants:  item[3]
            }
        });
        return todos
    };
    

    // ============================== Handler to delete user from contribution list ================================
    /* This deletes contributor from list and also adds back the contribution amount to quantity needed */
    handleRemoveContributor = (indexValue) => {
        //TRACE  && prtStart(FNAME, "handleRemoveContributor"); 

        let { participantEmail } = this.state;

        let contributions = this.state.contributions;

        /* get contributor list for a given item */
        let contributorList = this.getContributorList(contributions, indexValue);

        /* find participant in the contributor list and obtain amount participant was contributing. */
        let foundContributor = contributorList.find((contributor) => { return contributor.email === participantEmail });
        
        /* If partcipant not found in contributor list and invite was sent by organizer raise error */ 
        if (!foundContributor && this.props.inviteSentBy === "organizer") {
            //TRACE  && prtMsg("This is an invite from the organizer, but user is trying to delete from drop down list where their name does not appear")
            this.setState({formError: "No Action taken: as your name is not listed as a contributor for this item"});
            return;
        };

        /* If partcipant not found in contributor list and invite was sent by anonymous then tell the parent
           to prompt for Name and Email by setting showNameEmailModal to true. Also close panel so that 
           user is forced to rerender list, otherwise everytime uesr clicks remove my name they will keep getting modal */ 
        if (!foundContributor && this.state.inviteSentBy === "anonymous") {
            //TRACE  && prtMsg("This is an anonymous invite, seems like we do not have the name and email address.")
            //TRACE  && prtMsg("Calling setParentValues to trigger showNameEamilModal ")
            this.setState({showEmailModal: true, emailModalTitle: "To remove your name, confirm your email address below"})
            return;
        };

        let amountContributed = foundContributor.amount;

        /* delete contributor from list */
        let updatedContributorList  = contributorList.filter((contributor) => contributor.email !== participantEmail);
        let copyOfContributions = [...contributions];
        copyOfContributions[indexValue][4] = updatedContributorList;

        /* get quantityNeeded for the given item (based on indexValue) */
        let quantityNeeded   = copyOfContributions[indexValue][1]; // get quantity needed
        // let contributionAmt = copyOfContributions[indexValue][2];  // get contributionAmt

        /* add contribution amount back to quantity needed */
        quantityNeeded = parseInt(quantityNeeded, 10) + parseInt(amountContributed,10);
        // quantityNeeded = parseInt(quantityNeeded, 10) + parseInt(contributionAmt,10);

        /* set quantity needed to new value */
        copyOfContributions[indexValue][1] = quantityNeeded;
        /* set contribution amount back to same as quantity needed */
        // copyOfContributions[indexValue][2] = quantityNeeded;
        copyOfContributions[indexValue][2] = 1;  /* default this to 1 */

        /* mark item as "notUpdated" */
        copyOfContributions[indexValue][5] = "notUpdated";

        /* update contribution list in parent */
        this.handleUpdateContributionList(copyOfContributions, indexValue, quantityNeeded);
    }


   // ============================== Handler to delete user from helping hands list ================================

    /* This deletes participant form the list a */
    handleRemoveHelpingHandsContributor = (indexValue) => {
        //TRACE  && prtStart(FNAME, "handleRemoveHelpingHandsContributor");
        //TRACE  && prtInput("indexValue", indexValue);

        let participantEmail = this.state.participantEmail;
        let helpingHandslist = this.state.helpingHandsList;
        //TRACE  && prtVar("helpingHandslist", JSON.stringify(helpingHandslist,null,2));


        /* get contributor list for a given item */
        let participantList = this.getParticipantList(helpingHandslist, indexValue);
        //TRACE  && prtVar("participantList", JSON.stringify(participantList,null,2));

        /* find participant in the contributor list and obtain amount participant was contributing. */
        let foundParticipant = participantList.find((participant) => { return participant.email === participantEmail });
        //TRACE  && prtVar("foundParticipant", foundParticipant);
    
        // /* If participant not found in contributor list, do nothing. Exit function*/ 
        // if (!foundParticipant) {
        //     this.handleRaiseError("No Action taken: your name was not listed as a participant for this item.");
        //     return;
        // };

        //TRACE  && prtVar("this.props.inviteSentBy", this.props.inviteSentBy);
         /* If partcipant not found in contributor list and invite was sent by organizer raise error */ 
         if (!foundParticipant && this.props.inviteSentBy === "organizer") {
            //TRACE  && prtMsg("This is an invite from the organizer, but user is trying to delete from drop down list where their name does not appear")
            this.setState({formError: "No Action taken: as your name is not listed as a contributor for this item"});
            return;
        };

        /* If partcipant not found in contributor list and invite was sent by anonymous then tell the parent
           to prompt for Name and Email by setting showNameEmailModal to true. Also close panel so that 
           user is forced to rerender list, otherwise everytime uesr clicks remove my name they will keep getting modal */ 
        if (!foundParticipant && this.state.inviteSentBy === "anonymous") {
            //TRACE  && prtMsg("This is an anonymous invite, seems like we do not have the name and email address.")
            //TRACE  && prtMsg("Change 'this.state.showEmailModal' to true")
            this.setState({showEmailModal: true, emailModalTitle: "To remove name, please confirm the associated email address"})
            return;
        };

        /* Delete contributor from list */
        let updatedParticipantList  = participantList.filter((participant) => participant.email !== participantEmail);

        /* Make copy of help items */
        let copyOfHelpingHandsList = [...helpingHandslist];
        /* Replace participant list with list delete participant */
        copyOfHelpingHandsList[indexValue][3] = updatedParticipantList;
        /* Add 1 back to the count  */
        let peopleNeeded = copyOfHelpingHandsList[indexValue][1];
        copyOfHelpingHandsList[indexValue][1] = peopleNeeded + 1;
        /* Mark item as "notUpdated" */
        copyOfHelpingHandsList[indexValue][4] = "notUpdated";
        
        /* Update contribution list in parent */
        this.handleUpdateHelpingHandsList(copyOfHelpingHandsList);
    }


    /* Called by handleRemoveHelpingHandsContributor when ready to update helping hands list on database (eg Count Me In Button or remove me from list)*/
    handleUpdateHelpingHandsList = (helpingHandsList) => {
        //TRACE && prtStart(FNAME, 'handleUpdateHelpingHandsList')

        let { eventObj, participantEmail, externalToken, responseSubmitted, formError } = this.state;

        /* clear error message in case user click Submit without RSVP'ing,  */
        if (formError) {
            this.setState({formError: ''})
        }

        /* If user clicked Count Me In button, and responseSubmitted is true, then reset it to false in order to clear out 
           the ThankyouMessage and show submit button again */
        if (responseSubmitted) {
            this.setState({responseSubmitted: false})
        }

        /* Transform helpingHandsList to proper Document format. This is used for request object in API call */
        let todos =  this.mapHelpingHandsListToDocument(helpingHandsList);
        
        /* construct request object using the transformed todos document. Note that at end of 
           api call below, setState is called with original helpingHandsList(flexTable) format to update the store*/
        let updatedHelpListReqObj = {
            event_id: eventObj._id,
            todos
        }

        //TRACE && prtMsg("Below is request object used to update helping hands list")
        //TRACE && prtVar('updatedHelpListReqObj', updatedHelpListReqObj)

        let uri =  '/event/invite/todos';  /* url for external page */

        /* Update database with the updated ParticantList.It uses the transformed format. The store 
           is updated with flextable format was passed in as parameter  */
        let updateHelpingHandsList = new PicPutRequest("updateHelpingHandsList")
                .setUserId(participantEmail)
                .setUri(uri)
                .setRequestBody(updatedHelpListReqObj)
                // .setAuthToken(token)                       // OLD CODE
                .setAuthToken(externalToken)                       // NEW CODE
                .setLogTrace(true);     
            updateHelpingHandsList.exec().then((response) => {
                this.setState({helpingHandsList, userMadeContribution: true })    /* uses flextable format */
        }).catch((error) => {
            let errorResponse = updateHelpingHandsList.getError();
            let errmsg = '';
            errmsg = `Oops: unable to update help list for participant ${participantEmail}. May want to refresh page or try again`
            this.setState({formError: errmsg})
        });
    }

   // ============================== Handlers for EmailModal  ================================

    handleRetrieveMyUpdates = () => {
        /* To retrieve an anonymous user's information we need their name and email. While signaling to
          show email modal, we also clear any clear any prior errors by updating appropriate state variables. */
        //TRACE  && prtStart(FNAME, "handleRetrieveMyUpdates");
        //TRACE  && prtMsg("Change this.state.showEmailModal to true and set formError to '' ");
        this.setState({showEmailModal: true, formError: ''})
    }

    handleCloseEmailModal = () => {
        this.setState({showEmailModal: false})
    }

    handleCancelEmailModal = () => {
        this.setState({showEmailModal: false})
    }
    
    /* This handler is called whene anonymous user chooses to retrieve previous updates*/
    handleSubmitEmailModalForm = (formData) => {
        //TRACE  && prtStart(FNAME, "handleSubmitEmailModalForm");
        //TRACE  && prtInput("formData", JSON.stringify(formData,null,2));

        let eventId =           this.state.eventObj._id;
        let participantEmail =  formData.email;
        // let participantName =   formData.name;
        //TRACE  && prtVar("eventId", eventId);
        //TRACE  && prtVar("participantEmail", participantEmail);

        this.updateRvspFlagforCurrentParticipant(eventId, participantEmail, "handleSubmitEmailModal");

        // /* Check if participant exists. */ 
        // participantExist(eventId, participantEmail).then((response)=> {
        //     TRACE && prtMsg("Inside participantExist responseBlock")
        //     TRACE && prtVar("response", JSON.stringify(response,null,2))

        //     if (isEmpty(response) ) {
        //          /* If partcipant does not exist, set formError letting user know email was not found */
        //         TRACE && prtMsg("Participant Does Not Exist")
        //         this.setState({formError: `NotListed: Email '${participantEmail}' was not listed for this event`})
        //     } else {
        //         /* If participant exists, get attend status then set the participantEmail, participantName, attend status,
        //            close panels, and reset  */
        //         TRACE && prtMsg("Participant Exists")
        //         this.setState({participantEmail});
        //         getAttendeeStatus(eventId, participantEmail).then((data) => {
        //             let { attend, name: participantName } = data.participant;
        //             TRACE && prtVar("data.participant", JSON.stringify(data.participant,null,2))
        //             TRACE && prtVar("participantName", participantName)
        //             if (attend === "y") {
        //                 this.setState({participantName, participantEmail, rsvpFlag: "yes",
        //                     textButtonCheckMarks: {checkMark1: true,  checkMark2: false},
        //                     buttonClickedValue: 1, 
        //                     // panel1IconOpen: false, panel2IconOpen: false
        
        //                 })
        //             } else if (attend === "n") {
        //                 this.setState({participantName, participantEmail, rsvpFlag: "no",
        //                     textButtonCheckMarks: {checkMark1: false,  checkMark2: true},
        //                     buttonClickedValue: 2, 
        //                     // panel1IconOpen: false, panel2IconOpen: false
        //                 })
        //             }
        //         })
        //     }
        // })
    }

    /* Helper function used by both handleSubmitNameEmail Modal and handleSubmitEmail modal to set RSVP flag if participant already exists 
       Note that both these handlers are called only when we have an anonymous user */
    updateRvspFlagforCurrentParticipant = (eventId, participantEmail, calledBy = "handleSubmitNameEmailModal") => {

        // participantExist(eventId, participantEmail).then((response)=> {
        //     TRACE  && prtMsg("Inside participantExist responseBlock")
        //     TRACE  && prtVar("response", JSON.stringify(response,null,2))

        //     if (isEmpty(response) ) {
        //          /* If partcipant does not exist, set formError letting user know email was not found */
        //         //TRACE  && prtMsg("Participant Does Not Exist")
        //         // this.setState({formError: `NotListed: Email '${participantEmail}' was not registered for this event`})
        //         this.setState({participantEmail, participantName})

        //     } else {
        //         /* If participant exists, get attend status then set the participantEmail, participantName, attend status,
        //            close panels, and reset  */
        //         //TRACE  && prtMsg("Participant Exists")
        //         this.setState({participantEmail});
        //         getAttendeeStatus(eventId, participantEmail).then((data) => {
        //             let { attend, name: participantName } = data.participant;
        //             //TRACE  && prtVar("data.participant", JSON.stringify(data.participant,null,2))
        //             //TRACE  && prtVar("participantName", participantName)
        //             if (attend === "y") {
        //                 this.setState({participantName, participantEmail, rsvpFlag: "yes",
        //                     textButtonCheckMarks: {checkMark1: true,  checkMark2: false},
        //                     buttonClickedValue: 1, 
        //                     // panel1IconOpen: false, panel2IconOpen: false
        
        //                 })
        //             } else if (attend === "n") {
        //                 this.setState({participantName, participantEmail, rsvpFlag: "no",
        //                     textButtonCheckMarks: {checkMark1: false,  checkMark2: true},
        //                     buttonClickedValue: 2, 
        //                     // panel1IconOpen: false, panel2IconOpen: false
        //                 })
        //             }
        //         })
        //     }
        // })

        participantExist(eventId, participantEmail).then((response)=> {
            TRACE  && prtMsg("Inside participantExist() responseBlock")
            TRACE  && prtVar("response", JSON.stringify(response,null,2))

            /* participantExist */
            if (!isEmpty(response) ) {
                 /* If partcipant does not exist, set formError letting user know email was not found */
                //TRACE  && prtMsg("Participant Does Not Exist")
                // this.setState({formError: `NotListed: Email '${participantEmail}' was not listed for this event`})
                // this.setState({participantEmail, participantName})

            // } else {
                /* If participant exists, get attend status then set the participantEmail, participantName, attend status,
                   close panels, and reset  */
                //TRACE  && prtMsg("Participant Exists")
                this.setState({participantEmail});
                getAttendeeStatus(eventId, participantEmail).then((data) => {
                    let { attend, name: participantName } = data.participant;
                    //TRACE  && prtVar("data.participant", JSON.stringify(data.participant,null,2))
                    //TRACE  && prtVar("participantName", participantName)
                    if (attend === "y") {
                        this.setState({participantName, participantEmail, rsvpFlag: "yes",
                            textButtonCheckMarks: {checkMark1: true,  checkMark2: false},
                            buttonClickedValue: 1, 
                            // panel1IconOpen: false, panel2IconOpen: false
        
                        })
                    } else if (attend === "n") {
                        this.setState({participantName, participantEmail, rsvpFlag: "no",
                            textButtonCheckMarks: {checkMark1: false,  checkMark2: true},
                            buttonClickedValue: 2, 
                            // panel1IconOpen: false, panel2IconOpen: false
                        })
                    }
                })
            } else {
              /* Participant does not exist and this was called by handleSubmitEmailModal. The handleSubmitEmailModal is called when
                 user clicks on Retrieve my previous response link */
              if (calledBy === "handleSubmitEmailModal") {
                  this.setState({formError: `NotListed: Email '${participantEmail}' was not registered for this event`})
              }
            }
        })
    }


    //*************************************************************************
    // Utilities / or Help functions
    //*************************************************************************
    
    /* This returns the numeric value of the text button clicked, which is based on
       whether user clicked "yes" or "no". The numeric value is used in the render method 
       to pass the numeric value to the TextButtonGroup component.  */
    setButtonClicked = () => {
        if (this.state.rsvpFlag === "yes") {
            return 1;
        } else if (this.state.rsvpFlag === "no") {
            return 2;
        }
    }

    /* converts the contribution list from an array of objects to an array of array of items to be used by flex table */
    mapContribDataToFlexTable = (contributionList) =>  {
        let convertedArray = contributionList.map( (item) => {
            // return   [item.contribution, item.quantity, parseInt(item.quantity,10), "button", item.contributors, "notUpdated"]
            let contribution = item.quantity === 0 ? 0 : 1;
            return   [item.contribution, item.quantity, contribution, "button", item.contributors, "notUpdated"]
        }) 
        return convertedArray;
    }   

    /* converts the helping hands list from an array of objects to an array of array of items to be used by flex table */
    mapHelpDataToFlexTable = (hhList) =>  {
        let hhListArray = hhList.map( (todo) => {
            return   [todo.todo, todo.peopleNeeded, "button", todo.participants, "notUpdated"]
        }) 
        return hhListArray;
    }   

    /* Contributor list  is found as 4th item in table row . Created this help function so that
       in event it moves, I only need to change it one place */
    getContributorList = (contributionList, rowIndex) => {
        return contributionList[rowIndex][4];
    }

    /* checks to see if thare on lists */
    isNoLists = () => {
        return this.state.contributions.length === 0 && this.state.helpingHandsList.length === 0
    }

    showThankYouMessage = () => {
        let {responseSubmitted, rsvpFlag, formError, userMadeContribution }  = this.state;
        let response = false;
        if (responseSubmitted  &&  rsvpFlag === "yes"  && !formError && userMadeContribution) { /* user attending and made contribution(s)*/
            response = true;
        } else if (responseSubmitted  &&  rsvpFlag === "no"  && !formError && !userMadeContribution ) { /* user not attending and made no contribution*/
            response = true;
        } else if (responseSubmitted && this.isNoLists && rsvpFlag)  {  /* event has no lists and user rsvp'd either yes or no  */
            response = true;
        }
        return response;
    }

    showResponseButton = () => {
        return !this.showThankYouMessage()
    }

    getParentStateValue = (value) => {
        if (value === "participantEmail") { 
            return this.state.participantEmail 
        }
        if (value === "participantName")  { 
            return this.state.participantName  
        }
    }

    /* Use NameEmailModel to check if anonymous user is in a partcipant of either the contribution list or helpings 
       list we loaded for this event. If so, get their attendee status and set the  appropriate RSVP checkmark */
    isInOneOfTheParticipantLists = (participantEmail, contributions, helpingHandsList) => {
        // TRACE && prtStart(FNAME, "isInOneOfTheParticipantLists")
        // TRACE && prtInput("participantEmail", participantEmail);
        // TRACE && prtInput("contributions", JSON.stringify(contributions,null,2));
        // TRACE && prtInput("helpingHandsList", JSON.stringify(helpingHandsList,null,2));

        let response = false;

        /* check if participantEmail is listed in contribution list */
        // TRACE && prtMsg(`Looping thru contributions....`)
        contributions.forEach((contribution) => {
            if (contribution[4].length > 0) {
                /* check participant array list */
                let participantIndexValue = contribution[4].findIndex((participant) => participantEmail === participant.email);
                if ( participantIndexValue !== -1 ) { response = true }
                return 
            }
        })
        
        /* check if participantEmail is listed in helping hands list */
        // TRACE && prtMsg(`Looping thru hhlist....`)
        helpingHandsList.forEach((helpingHandsItem) => {
        //    console.log(JSON.stringify(helpingHandsItem))
               if (helpingHandsItem[3].length > 0) {
                /* check for participant array list */
                let hhIndexValue = helpingHandsItem[3].findIndex((participant) => participantEmail === participant.email);
                if ( hhIndexValue !== -1 ) { response = true };
                return;
            }
        })
        // TRACE && prtMsg(`Response is ${response}`)
        return response;
    }

    /* display spinner when data is loading  */
      displaySpinner = () => (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div>
            Fetching Event
            </div>
            <ProgressSpinner />
        </div>
    )

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        //TRACE && prtStart(FNAME, "render()")

        let errormsg_only = '';
        let errormsg = this.state.formError || '';
        if (errormsg) {
            let errormsg_array = errormsg.split(':');
            errormsg_only = errormsg_array[1];
        }

        let { _id, eventTitle, location, startDate, startTime, endDate, endTime, 
              organizer, eventMessage, userName } = this.state.eventObj;
        
        let { clearPage, rsvpFlag, panel1IconOpen, panel2IconOpen, responseSubmitted, 
              displayLists, formError, userMadeContribution, participantEmail, dataLoaded, externalToken } = this.state;

        if (!userName) { userName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname };

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");
        let showSkyScraper = false;

        let showThankYouMessage = this.showThankYouMessage();
        let showResponseButton  = this.showResponseButton();

        //TRACE && prtVar("responseSubmitted ", responseSubmitted);
        //TRACE && prtVar("userMadeContribution ", userMadeContribution);
        //TRACE && prtVar("formError Value", formError);
        //TRACE && prtVar("formError evaluation", formError ? true : false);
        //TRACE && prtVar("rsvpFlag ",  rsvpFlag  ? true : false);
        //TRACE && prtVar("---------------------------------------");
        //TRACE && prtVar("showThankYouMessage ", showThankYouMessage);
        //TRACE && prtVar("showResponseButton ",  showResponseButton);

        /* if user did not elect to use alternate organizer name, default to organiner name*/
        //TRACE && prtVar(`ORGANIZER : ${organizer}`)
        //TRACE && prtVar(`USER NAME : ${userName}`)

        if (!organizer) {
            organizer = userName;
        }

        return (
            <div> 
               <Helmet>
                    <title>Invitation Pitch In Club</title>
                    <meta name="description" content="Invitation Pitch In Club" />
               </Helmet>

               <PageHeader pageName="home" />  

               <VisibilityWrapper show={showAd} contentType="advertisement">
               <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                   {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                   {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                   {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
               </div>
               </VisibilityWrapper>  

               <div className="app-container-invitation">    
                  <div className="pic-dashboard-container"> 
                    <div className="pic-invitation-container">
                        <TopBorder />
                        <div style={{display: "flex", justifyContent: "center", marginTop: ".3rem"}}>
                        <ErrorMessage text={errormsg} allowClose={true} clearError={this.clearErrorMessage} />
                        </div>
                        {dataLoaded ? (
                            eventDetailSection(_id, eventTitle, location, startDate, startTime, endDate, endTime, organizer, eventMessage, clearPage)
                           ):
                            this.displaySpinner()
                        }
                        <div style={{display: "flex", justifyContent: "center" }}>
                            <HorizRule color="#CC6600" pctWidth="60%" thickness="2px"  />
                        </div>
                        <div className="text-button-group-container">
                            <TextButtonGroup 
                                buttonGroupLabel="Will you be Attending?"
                                button1TextAndStyle="Yes:success"
                                button2TextAndStyle="No:fail"
                                buttonClicked={this.state.buttonClickedValue}
                                checkMarks={this.state.textButtonCheckMarks}
                                onClickHandler={this.handleTextButtonGroup}
                                clearCheckMarks={this.state.clearNameEmailModalCheckMarks}
                            />
                        </div>
                        <div style={{display: "flex", justifyContent: "center" }}>
                            <HorizRule color="#CC6600" pctWidth="60%" thickness="2px"  />
                        </div>
                        {this.state.participantEmail === "none" && (
                            <div>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div> 
                                    <MuiToolTip title="Used to view or update previous response" placement="right">
                                    <div className="pic-event-retrieve-link" onClick={this.handleRetrieveMyUpdates}>Retrieve my previous response</div> 
                                    </MuiToolTip>
                                </div>  
                            </div>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {errormsg.startsWith("NotListed") && <h5 style={{color: 'red', padding: '1rem .5rem', fontSize: '1.4rem'}}>{errormsg_only}</h5> }
                            </div>
                            </div>
                        )}
                        {!this.isNoLists() && (
                        <div> 
                            <div className="pic-event-message-container">
                                <div className="pic-event-prompt">To Pitch In, expand panels below, then submit response. </div>
                            </div>
                        </div> 
                        )}
                        <div className="pic-event-modifier-mt2">
                               <div>
                                    { this.state.contributions.length > 0 &&
                                        (<PicInvitationContribPanel 
                                            open={panel1IconOpen} handleOnClickForPanel={this.handleOnClickForPanel1} raiseErrorHandler={this.handleRaiseError} 
                                            dataset1={this.state.eventObj}
                                            dataset2={this.state.contributions}
                                            getParentStateValue={this.getParentStateValue}
                                            handleContribCountMeInButton={this.handleContribCountMeInButton}
                                            handleRemoveContributor={this.handleRemoveContributor}
                                            handleChangeQuantity={this.handleChangeQuantity}
                                            /*handleChangeDataSet2={this.handleUpdateContributionList}*/
                                            inviteSentBy={this.state.inviteSentBy}
                                            setParentStateValues={this.handleSetParentStateValues}
                                        />)
                                    }
                                    <div className="pic-event-modifier-mt2" />
                                    { this.state.helpingHandsList.length > 0 &&
                                       ( 
                                        <PicInvitationHelpPanel
                                            open={panel2IconOpen} handleOnClickForPanel={this.handleOnClickForPanel2} raiseErrorHandler={this.handleRaiseError} 
                                            dataset1={this.state.eventObj}
                                            dataset2={this.state.helpingHandsList}
                                            handleHelpingHandsCountMeInButton={this.handleHelpingHandsCountMeInButton}
                                            handleRemoveContributor={this.handleRemoveHelpingHandsContributor}
                                            getParentStateValue={this.getParentStateValue}
                                            // handleChangeDataSet2={this.handleUpdateHelpingHandsList}
                                            inviteSentBy={this.state.inviteSentBy}
                                            setParentStateValues={this.handleSetParentStateValues}
                                        /> )
                                    }
                                <div/> 
                            </div> 
                        </div> 
                       {showResponseButton && (   
                        <div>
                            <div className="pic-event-modifier-mt4vary" />
                            <div className="pic-event-pitchin-button-container">
                                <SimpleButton  buttonText="Submit Response" words={3} 
                                            onClickHandler={this.handleSubmitResponse} />
                            </div>
                            <div className="pic-event-modifier-mt2vary" />
                        </div>)
                        }  
                        {showThankYouMessage && (
                            <div className="pic-event-message-container">
                                <div className="pic-event-modifier-mt5xx">&nbsp;</div>
                                <div className="pic-event-thankyou-message">Thanks for getting back to us</div>
                                <div className="pic-event-thankyou-message-sub">
                                    To come back to this invitation, click on the 'View Invite' button in the invitation email or link originally sent to you. 
                                    You may close this window.
                                </div>
                            </div>)
                        }
                        <CancelSubmitModal showModal={this.state.showCancelSubmitModal} 
                            modalText="Would you like to Pitch In? &nbsp; &nbsp;If so, click Cancel, otherwise Submit"
                            affirmText="Submit" 
                            cancelHandler={this.handleCancelModal} 
                            closeHandler={this.handleCloseModal} 
                        />
                        <NameEmailModal 
                            showModal={this.state.showNameEmailModal}  
                            title={this.state.nameEmailModalTitle}
                            closeHandler={this.handleCloseNameEmailModal}
                            cancelHandler={this.handleCancelNameEmailModal}
                            submitFormHandler={this.handleSubmitNameEmailModalForm}
                        />  
                        <EmailModal 
                            showModal={this.state.showEmailModal}  
                            title={this.state.emailModalTitle}
                            closeHandler={this.handleCloseEmailModal}
                            cancelHandler={this.handleCancelEmailModal}
                            submitFormHandler={this.handleSubmitEmailModalForm}
                        />   
                        <MessageModal 
                            showModal={this.state.showMessageModal} 
                            message="Can you first please let us know if you will be attending or not. Thanks"
                            cancelHandler={this.handleCancelMessageModal}
                        />  
                        <div className="rc-flex-container-center" >
                            {errormsg.startsWith("RSVP Missing") && <h5 style={{color: 'red', paddingBottom: '2.7rem'}}>{errormsg_only}</h5>}
                        </div>
                    </div>
                    <VisibilityWrapper show={showSkyScraper} contentType="advertisement" >
                        {displayAd("skyscraper", "desktop", {marginLeft: '3rem', marginTop: '4.2rem'})}
                    </VisibilityWrapper>  
                      </div>
               </div>
               <VisibilityWrapper show={showAd} contentType="advertisement" >
               <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                   {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                   {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                   {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
               </div> 
               </VisibilityWrapper>
               <Footer  />       
            </div>
        );
    };
};

const mapDispatchToProps = (dispatch) => ({
    startLogout:  () => dispatch(startLogout()),
    /* used to clear out application error */
    picAppError:          (errmsg) => dispatch(picAppError(errmsg))
    
})

const mapStateToProps = (state) => {
    return {
        event: state.event,
        auth: state.auth,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PicInvitation);



// WEBPACK FOOTER //
// ./src/components/PicInvitation.js